import { useState, useEffect } from 'react';

interface Props {
    expiresIn: number;
    className?: string;
    callback?: () => void;
}

export const CountDownTimer = ({ expiresIn, className = '', callback }: Props) => {
    const [timeLeft, setTimeLeft] = useState(expiresIn);

    useEffect(() => {
        const interval = setInterval(() => {
            if (timeLeft <= 1) {
                if (callback) {
                    callback();
                }

                return () => clearInterval(interval);
            }

            setTimeLeft((t) => t - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [timeLeft]);

    return <span className={className}>{timeLeft}</span>;
};
